import { Button, Dialog, DialogActions, DialogTitle } from "@mui/material";
import { useEffect, useState } from "react";
import CountrySelect from "./AutoComplete";

function ConfirmationDialogRaw(props) {
    const { onClose, open,element,callbk } = props;
    const [value, setValue] = useState(''); 
  
    useEffect(() => { 
        console.log(element, "hii");
        const {key,elements}=element;
        console.log(elements && elements[0]);
    }, [element]);
  
     
  
    const handleCancel = () => {
      onClose();
    };
  
    const handleOk = () => {
      onClose();
    };
   
    const formhandel=(data)=>{
        callbk(data);
        
    }
    return (
      <Dialog
        sx={{ '& .MuiDialog-paper': { width: '80%',padding:'15px' } }}
        maxWidth="xs" 
        open={open}  
      > 
      <CountrySelect cancelhandel={handleCancel} handelform={formhandel}/>
        
      </Dialog>
    );
  }
  export default ConfirmationDialogRaw;